import * as React from "react";
import { t } from "i18next";
import { Space } from "antd";
import { observer } from "mobx-react-lite";
import { ColumnsSettings } from "src/components/tables/ColumnsSettings";
import { EntityEditorModal } from "src/components/EntityEditor";
import styles from "./EntityList.module.less";
import { AsyncTableView } from "../AsyncTableView";
import { EntityFiltersPageStore } from "../EntityFiltersPageStore";
import { EntityActions } from "./EntityActions";
import { FilterSwitch } from "./FilterSwitch";
import { InputSearch } from "./InputSearch";
import { EntityFilters, ZEntityRow } from "./types";
import { DefaultViewButton } from "./DefaultViewButton";
import { EntityCreateButton } from "./EntityCreateButton";

interface PropsEntityList {
  store: EntityFiltersPageStore;
  onRowClick?(row: ZEntityRow, index?: number): void;
}

export const EntityList: React.FC<PropsEntityList> = observer(
  ({
    store,
    store: {
      tableStore,
      canCreate,
      subCardStore,
      actionsMeta,
      currObjId,
      currObjName,
      defTSettingsStore,
    },
    onRowClick,
  }) => {
    if (!tableStore) return null;
    return (
      <>
        <div className={styles.content}>
          <AsyncTableView<ZEntityRow, EntityFilters>
            headerExtra={
              <div className={styles.header}>
                <div className={styles.headerInner}>
                  <InputSearch store={tableStore} />
                  <Space>
                    <FilterSwitch store={store} />
                    <ColumnsSettings
                      store={tableStore}
                      freezeLine
                      extraButtons={
                        defTSettingsStore?.displayAttrs ? (
                          <DefaultViewButton
                            onClick={() =>
                              defTSettingsStore?.applySettings(true)
                            }
                          />
                        ) : undefined
                      }
                    />
                    <EntityActions store={store} />
                    {canCreate && (
                      <EntityCreateButton
                        objectName={currObjName}
                        objectId={currObjId}
                        onClick={
                          actionsMeta?.useModal
                            ? () => store.openCreation()
                            : undefined
                        }
                      />
                    )}
                  </Space>
                </div>
              </div>
            }
            onRowClick={onRowClick}
            store={tableStore}
            columns={tableStore.columns}
            useHeader
            usePagination
            useSelection
            templateToken={store.tabletemplateToken ?? undefined}
          />
        </div>
        <EntityEditorModal
          store={subCardStore}
          modalProps={{
            open: !!subCardStore,
            onCancel: () => store.closeCreation(),
          }}
          editorProps={{
            submitText: t("Add"),
            onSuccess: (entityId) => {
              if (entityId) {
                onRowClick?.({ id: entityId });
              }
              store.handleNewRow();
            },
          }}
        />
      </>
    );
  },
);
